import { combineReducers } from 'redux';
import  viewMode from './viewModeReducers';

export default combineReducers({
  viewMode
});



// WEBPACK FOOTER //
// ./src/redux/reducers/rootReducer.js